import type { SidePanel } from '../types';

export const ConfirmDialog: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./ConfirmDialogPanel.vue')),
};
